module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n" + _vm._s(_vm.serverLocation) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-238190e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/SystemLocation.vue
// module id = 980
// module chunks = 2